import { render } from "./ApprovalsListCardEditable.vue?vue&type=template&id=592a6a18"
import script from "./ApprovalsListCardEditable.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardEditable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__